import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

export type WithdrawalSource = 'Lottery' | 'Cash Safe';

export interface CashDepositEntry {
  id: number;
  date: string;
  employeeId: number | null;
  cashDeposit: number;
  cashWithdrawals: number;
  withdrawalSource: WithdrawalSource | null;
  total: number;
  notes: string | null;
  userId: number;
  createdDate: number;
}

export interface CreateCashDepositRequest {
  date?: string;
  employeeId: number;
  cashDeposit: number;
  cashWithdrawals: number;
  withdrawalSource?: WithdrawalSource;
  total: number;
  notes?: string;
}

export type UpdateCashDepositRequest = Partial<CreateCashDepositRequest>;

export interface PaginatedCashDepositResponse {
  data: CashDepositEntry[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const cashDepositApi = {
  getEntries: async (
    params: { page?: number; limit?: number },
    token: string
  ): Promise<PaginatedCashDepositResponse> => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.append('page', params.page.toString());
    if (params.limit) searchParams.append('limit', params.limit.toString());
    const query = searchParams.toString();
    return apiRequest<PaginatedCashDepositResponse>(
      buildApiUrl(`${API_CONFIG.ENDPOINTS.CASH_DEPOSITS.BASE}${query ? `?${query}` : ''}`),
      {
        method: 'GET',
        headers: getAuthHeaders(token),
      }
    );
  },

  createEntry: async (data: CreateCashDepositRequest, token: string): Promise<CashDepositEntry> => {
    return apiRequest<CashDepositEntry>(
      buildApiUrl(API_CONFIG.ENDPOINTS.CASH_DEPOSITS.BASE),
      {
        method: 'POST',
        headers: getAuthHeaders(token),
        body: JSON.stringify(data),
      }
    );
  },

  updateEntry: async (id: number, data: UpdateCashDepositRequest, token: string): Promise<CashDepositEntry> => {
    return apiRequest<CashDepositEntry>(
      buildApiUrl(API_CONFIG.ENDPOINTS.CASH_DEPOSITS.BY_ID(id)),
      {
        method: 'PUT',
        headers: getAuthHeaders(token),
        body: JSON.stringify(data),
      }
    );
  },

  deleteEntry: async (id: number, token: string): Promise<void> => {
    return apiRequest<void>(
      buildApiUrl(API_CONFIG.ENDPOINTS.CASH_DEPOSITS.BY_ID(id)),
      {
        method: 'DELETE',
        headers: getAuthHeaders(token),
      }
    );
  },
};
